// src/firebase/analyticsPreference.js
//
// The visitor's Google Analytics choice, remembered per device. Analytics is
// ON by default with an opt-out switch on the Privacy Policy page (the
// owner's call - see multi-tenant-plan.md §22). Once someone opts out,
// FirebaseContext never calls getAnalytics() on later visits, so gtag.js is
// never loaded and sets no cookies.
//
// Every storage access is wrapped: private windows and blocked site data make
// localStorage throw, and that must read as "not opted out" rather than break
// the app. The choice then lasts only for the current page load.

const OPT_OUT_KEY = 'zimzo-analytics-opt-out';

export const isAnalyticsOptedOut = () => {
  try {
    return window.localStorage.getItem(OPT_OUT_KEY) === '1';
  } catch {
    return false;
  }
};

export const saveAnalyticsOptOut = (optedOut) => {
  try {
    if (optedOut) {
      window.localStorage.setItem(OPT_OUT_KEY, '1');
    } else {
      window.localStorage.removeItem(OPT_OUT_KEY);
    }
  } catch {
    // Not persisted - the choice still applies until the page is reloaded.
  }
};

// Removes the _ga / _ga_<id> cookies gtag.js already set on this device.
// gtag's default cookie_domain is 'auto', which writes them on the highest
// domain it can ('.zimzo.shop'), so the host and its parent are both tried.
export const clearAnalyticsCookies = () => {
  try {
    const names = document.cookie
      .split(';')
      .map((cookie) => cookie.split('=')[0].trim())
      .filter((name) => name === '_ga' || name.startsWith('_ga_'));
    if (!names.length) return;

    const host = window.location.hostname;
    const domains = [host, `.${host}`, `.${host.split('.').slice(-2).join('.')}`];

    names.forEach((name) => {
      document.cookie = `${name}=; Max-Age=0; path=/`;
      domains.forEach((domain) => {
        document.cookie = `${name}=; Max-Age=0; path=/; domain=${domain}`;
      });
    });
  } catch {
    // Cookies blocked or unavailable - nothing to clear.
  }
};
